import moment from 'moment-timezone'

export const stripIsoTimeZone = value => {
  if (typeof value !== "string") return value

  return value.replace(/(?:Z|[+-]\d{2}:?\d{2})$/, "")
}

export const parseDateTime = (value, ignoresTimeZone = false) => {
  if (!value) return moment.invalid()

  return ignoresTimeZone
    ? moment.parseZone(stripIsoTimeZone(value))
    : moment(value).local()
}

export const toNativeDateValue = value => {
  const date = value ? moment(value, "YYYY-MM-DD", true) : moment.invalid()
  return date.isValid() ? date.format("YYYY-MM-DD") : ""
}

export const toNativeDateTimeValue = (value, ignoresTimeZone = false) => {
  const date = parseDateTime(value, ignoresTimeZone)
  return date.isValid() ? date.format("YYYY-MM-DDTHH:mm:ss") : ""
}

export const fromNativeDateValue = value => value

export const fromNativeDateTimeValue = value => {
  if (!value) return ""

  return moment(value, "YYYY-MM-DDTHH:mm:ss", true).format("YYYY-MM-DDTHH:mm:ssZ")
}

export const isValidDateInput = value => {
  if (typeof value !== "string") return false

  return moment(value, "YYYY-MM-DD", true).isValid()
}

export const isValidTimeInput = value => {
  if (typeof value !== "string") return false

  return /^\d{2}:\d{2}:\d{2}$/.test(value)
    && moment(value, "HH:mm:ss", true).isValid()
}

export const isValidDateTimeInput = value => {
  if (typeof value !== "string") return false

  return /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?(?:Z|[+-]\d{2}:?\d{2})$/.test(value)
    && moment(value, moment.ISO_8601, true).isValid()
}
